import { Stack } from "@mui/material";
import { DateRangePicker } from "@components/date-range-picker/date-range-picker";
import { DateRangeValue } from "@components/date-range-picker/date-range-picker-types";

interface AnalyticsSearchFilterProps {
  /** Currently selected date range. */
  value: DateRangeValue;

  /** Called when the user accepts a date range selection. */
  onChange: (value: DateRangeValue) => void;
}

/**
 * Displays the analytics date range filter and forwards accepted selections.
 */
export function AnalyticsSearchFilter({
  value,
  onChange,
}: AnalyticsSearchFilterProps): JSX.Element {
  return (
    <Stack
      data-testid="analytics-search-filter"
      sx={{
        flex: 1,
        display: "flex",
        justifyContent: "center",
      }}
    >
      <DateRangePicker value={value} onAccept={onChange} />
    </Stack>
  );
}
